<template>
  <div class="modal-popup">
    <div class="modal fade" id="checkChangePopup" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
        <div class="modal-header">
          <h3 class="title mb-2 ml-3">Değişiklik Detayı</h3>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" class="la la-close"></span>
          </button>
        </div>
          <div class="modal-body">
            <div class="contact-form-action">
              <div class="col-lg-12">
                <div class="card-item p-3" v-if="checkChange != null">
                  <div class="row" >
                    <div class="contact-form-action col-sm-6">
                      <div class="input-box"><label class="label-text">Önceki Fiyat :
                      </label> <span class="text">{{checkChange.totalPrice-checkChange.priceDifference | toCurrency}}</span></div>
                      <div class="input-box"><label class="label-text">Yeni Fiyat :
                      </label> <span class="text">{{checkChange.totalPrice | toCurrency}}</span></div>
                      <div class="input-box"><label class="label-text">Fark :
                      </label> <span class="text" style="color: #2a7cfa;font-size: 19px;">{{checkChange.priceDifference | toCurrency}}</span>
                      </div>
                    </div>
                    <div class="contact-form-action col-sm-6">
                      <div class="input-box" v-if="checkChange.needRefund" ><label class="label-text">İade Tutarı
                        :</label> <span class="text">{{checkChange.refundAmount | toCurrency}}</span></div>
                    </div>
                  </div>
                  <span v-if="checkChange.needRefund" class="badge badge-warning py-1 px-2"
                        style="color: white;">
                  İade yapılması gerekiyor!
                  </span>
                    <span v-if="checkChange.belowPartialPayment" class="badge badge-warning py-1 px-2"
                            style="background-color: #d32727;color: white;">
                    Parçalı ödeme limitinin altında!
                    </span>
                  <span v-if="checkChange.priceDifference === 0" class="badge badge-success py-1 px-2"
                        style="color: white;">
                  Değişiklik için ücret ödenmesi gerekmiyor.
                  </span>
                </div>
              </div>
              <div class="contact-form-action ml-4">
<!--              <form method="post">-->
<!--                <div class="row">-->
<!--                  <div class="col-sm-6">-->
<!--                    <div class="input-box">-->
<!--                      <label class="label-text">Acente</label>-->
<!--                      <div class="form-group">-->
<!--&lt;!&ndash;                        <select v-model="selectedAgency" id="selectedAgency" class="select-contain-select" type="text" placeholder="" style="width: auto">&ndash;&gt;-->
<!--&lt;!&ndash;                          <option v-for="agency in agencyList" :value="agency" style="color: black"> {{agency.name}} </option>&ndash;&gt;-->
<!--&lt;!&ndash;                        </select>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </form>-->
            </div>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button type="button" class="btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">Cancel</button>
            <button @click="recalculate" :class="loading ? 'disabled' : ''" type="button" class="theme-btn theme-btn-small">
              <i v-if="loading" class="la la-spinner la-spin"></i>Tekrar Fiyatla</button>
            <button @click="accept" :class="loading ? 'disabled' : ''" type="button" class="theme-btn theme-btn-small">
              <i v-if="loading" class="la la-spinner la-spin"></i>Onaylıyorum</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import messagePopupManager from "../../util/messagePopupManager";

export default {
  name: "CheckChangePopup",
  data:function (){
    return{
      loading:false,
      selectedAgency:null
    }
  },
  computed:{
    checkChange:{
      get(){
        return this.$store.getters.getChangeResponse;
      }
    },
    agencyList:{
      get(){
        return this.$store.getters.getAgencyList
      }
    }
  },
  methods:{
    recalculate(){
      this.$store.commit("setReCalculate", true);
      this.$store.dispatch("checkChange").then(response => {

      });
    },
    accept(){
      if(!this.loading) {
        this.loading = true;
        this.$store.dispatch("change", this.selectedAgency).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Başarılı',
            text: '',
          })

          window.location.href="/bookings/"+response.booking.id;
          $("#checkChangePopup").modal("hide");
        }).catch((error)=>{
          messagePopupManager.showError("Hata", error.response.data.message);
        }).finally(()=>{
          this.loading = false;
        })
      }
    }
  },
  updated() {
    setTimeout(function () {
      $(".select-contain-select").selectpicker('refresh');
    }, 100);
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Select One'
    });
  }
}
</script>

<style scoped>

</style>